import angular from 'angular';
import uiRouter from 'angular-ui-router';
import {configurationModule} from '../configuration/configuration.js';


import {DataGridComponent} from './list/dataGrid.component.js';
import {ListViewComponent} from './list/listView.component.js';
import {ModalFormComponent} from './form/modalForm.component.js';
import FieldViewConfiguration from './fieldView/FieldViewConfiguration.js';

const crud = angular.module('crud', [uiRouter, configurationModule.name]);

crud.component('inDataGrid', DataGridComponent);
crud.component('listView', ListViewComponent);
crud.component('modalForm', ModalFormComponent);

crud.provider('FieldViewConfiguration', FieldViewConfiguration);

crud.directive('inListActions', require('./list/listActions.js'));

crud.directive('column', require('./column/column.js'));
crud.directive('inStringColumn', require('./column/inStringColumn.js'));
crud.directive('inDateColumn', require('./column/inDateColumn.js'));
crud.directive('inTemplateColumn', require('./column/inTemplateColumn.js'));
crud.directive('inReferenceColumn', require('./column/inReferenceColumn.js'));


export {crud};



// WEBPACK FOOTER //
// ./app/components/common/crud/crud.js